import { Injectable } from '@angular/core';

declare let THREE: any;
import { BaseHandler } from './BaseHandler';
import { StageService } from '../../../../services/stage.service';
import { ObjectCheckerService } from '../../../../services/object-checker.service';
import { CollisionService } from '../../../../services/collision/collision.service';

@Injectable()
export class FloorObjectHandler extends BaseHandler {
  private staticObjects;

  constructor(
    private objectCheckerSrvc: ObjectCheckerService,
    private stageService: StageService,
    private collisionSrvc: CollisionService
  ) {
    super();
  }

  canExecute(entity) {
    return (
      !this.objectCheckerSrvc.isWallMountable(entity) &&
      !this.objectCheckerSrvc.isWallEmbeddable(entity)
    );
  }

  getRaycastObjects(): Array<any> {
    return [...this.stageService.getCompoundFloor().children, this.stageService.getGround()];
  }

  private getStaticObjects() {
    return this.stageService
      .getCompoundFloor()
      .children.reduce((result, child) => result.concat(child.children), [])
      .filter(obj => obj.name === 'Accessory' || obj.name === 'wall');
  }

  private getYRotation(object, staticObjects, newPosition): number {
    const entity = object.userData.entity;

    const expandedSize = new THREE.Vector3(
      Math.max(entity.length, entity.width),
      entity.height,
      Math.min(entity.length, entity.width)
    ).addScalar(15);

    const collided = this.collisionSrvc.isCollide(object, staticObjects, {
      newPosition,
      newSize: expandedSize
    });

    if (collided && this.objectCheckerSrvc.isWall(collided)) {
      return collided.rotation.y;
    } else {
      return object.rotation.y;
    }
  }

  dragBegin(intersection) {
    let handled = false;
    const ghostObject = this.ghostObject;
    const entity = ghostObject.userData.entity;
    const { point: intersectionPoint, object: intersectedObject } = intersection[0];
    const newPosition = intersectionPoint.setY(intersectionPoint.y + entity.height / 2);
    const newRotation = ghostObject.rotation.clone();

    this.staticObjects = this.staticObjects || this.getStaticObjects();

    newRotation.y = this.getYRotation(ghostObject, this.staticObjects, newPosition);

    const collided = this.collisionSrvc.isCollide(ghostObject, this.staticObjects, {
      newPosition,
      newRotation
    });

    if (!collided) {
      handled = true;
      ghostObject.rotation.y = newRotation.y;
      ghostObject.position.copy(newPosition);
      ghostObject.userData.parent = intersectedObject;
    }

    return handled;
  }

  dragEnd(object) {
    this.staticObjects = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectAdd/Handlers/FloorObjectHandler.ts